import { IEpisodeDTO } from '@/modules/episodes/dtos/episode.dto';
import { IEpisode } from '@/modules/episodes/entities/episode.entity';

export class EpisodeMapper {
  public static toPresentation(episode: IEpisodeDTO): IEpisode {
    return {
      id: episode.id,
      title: episode.titulo,
      author: episode.autor,
      status: episode.status,
      duration: episode.duracao,
      createdAt: episode.criadoEm,
      thumbnail: episode.thumbnail,
      description: episode.descricao,
      endedAt: episode.dataFinalizacao,
      presignedUrl: episode.presignedUrl,
    };
  }

  public static toDTO(episode: IEpisode): IEpisodeDTO {
    return {
      id: episode.id,
      autor: episode.author,
      titulo: episode.title,
      status: episode.status,
      duracao: episode.duration,
      criadoEm: episode.createdAt,
      thumbnail: episode.thumbnail,
      descricao: episode.description,
      dataFinalizacao: episode.endedAt,
      presignedUrl: episode.presignedUrl,
    };
  }
}
